import consumer from "./consumer";

const discussionQuestionsChannel = function () {
  consumer.subscriptions.create("DiscussionQuestionsChannel", {
    connected() {
      // console.log('connected');
    },

    disconnected() {
      // console.log('disconnected')
      // Called when the subscription has been terminated by the server
    },

    received(data) {
      $("#response-area").html(data.body);
    }
  });
};

export default discussionQuestionsChannel;
